import React, { FC, useState } from 'react';
import { useDispatch, ConnectedProps, connect, useSelector } from 'react-redux';
import { AuthActions } from 'Store/Auth/Auth.actions';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { getDomain } from 'Store/MultiDomain/MultiDomain.selector';
import { IResetPasswordRequest } from 'Data/interfaces/Auth/IResetPasswordRequest';
import schema, { schemaPassword } from './resetPassword.schema';
import BoxContainer from 'Components/UI/Containers/BoxContainer/BoxContainer';
import Button from 'Components/UI/Button';
import Form from 'Components/UI/Form/Form';
import Field from 'Components/UI/Field';
import Link from 'Components/UI/Link';
import Background from '../Backgroud/background';
import FloatingFeedback from 'Components/UI/Input/TextInput/FloatingFeedback/FloatingFeedback';
import { Http } from 'Utils/Http';
import styles from './ResetPassword.module.scss';

const mapState = (state: IGlobalReducerState) => ({
  ...state.auth,
});

const connector = connect(mapState);

type Props = ConnectedProps<typeof connector>;

const ResetPassword: FC<Props> = (props) => {
  const dispatch = useDispatch();
  const domain = useSelector(getDomain);
  const email = Http.GetQueryParams('email') || '';
  const code = Http.GetQueryParams('code') || '';

  const [password, setPassword] = useState<string | undefined>(undefined);
  const [passwordFocus, setPasswordFocus] = useState<boolean>(false);
  const [confirmPassword, setConfirmPassword] = useState<string | undefined>(undefined);
  const [confirmPasswordFocus, setConfirmPasswordFocus] = useState<boolean>(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const resetPassword = (data: IResetPasswordRequest) => {
    data.code = code.replace(/ /g, '+');
    dispatch(AuthActions.userResetPassword(data));
  };

  return (
    <Background>
      <BoxContainer height={domain?.LogoUrl ? 450 : 400} width={403}>
        <div className={styles['contentWrapper']}>
          <h2 className={styles['title']}>Recuperar Senha</h2>
          <Form schema={schema} initialValues={{email}} onSubmit={resetPassword}>
            <Field
              name='email'
              label='E-mail'
              icon='arroba'
              placeholder='usuario@dominio.com.br'
              disabled={!!email}
            />
            <Field
              name='password'
              label='Senha'
              icon='cadeado'
              type={showPassword ? 'text' : 'password'}
              rightIcon={showPassword ? 'notVisualizar' : 'visualizar'}
              rightIconSize={12}
              onRightIconClick={() => setShowPassword((prev) => !prev)}
              onInput={setPassword}
              onBlur={() => setPasswordFocus(false)}
              onFocus={() => setPasswordFocus(true)}
            />
            <FloatingFeedback
              name='password'
              schema={schemaPassword}
              inputValue={password}
              visible={passwordFocus}
              className={styles['passwordFeedback']}
            />

            <Field
              name='confirmPassword'
              label='Confirme a senha'
              icon='cadeado'
              type={showConfirmPassword ? 'text' : 'password'}
              rightIcon={showConfirmPassword ? 'notVisualizar' : 'visualizar'}
              rightIconSize={12}
              onRightIconClick={() => setShowConfirmPassword((prev) => !prev)}
              onInput={setConfirmPassword}
              onBlur={() => setConfirmPasswordFocus(false)}
              onFocus={() => setConfirmPasswordFocus(true)}
            />
            <FloatingFeedback
              name='confirmPassword'
              schema={schemaPassword}
              inputValue={confirmPassword}
              visible={confirmPasswordFocus}
              className={styles['confirmPasswordFeedback']}
              context={{ password }}
            />

            <div className={styles['buttonWrapper']}>
              <Button
                width='100%'
                type='primary'
                htmlType='submit'
                loading={props.isLoading}
              >
                Confirmar
              </Button>
            </div>
          </Form>

          <div className={styles['backLoginWrapper']}>
            <Link to='/login'>
              Voltar para o login
            </Link>
          </div>

          {domain?.LogoUrl && (
            <p className={styles['powered-by']}>
              Powered by <span>Coordly</span>
            </p>
          )}
        </div>
      </BoxContainer>
    </Background>
  );
};

export default connector(ResetPassword);
